import { render, staticRenderFns } from "./PromoDates.vue?vue&type=template&id=65192434&"
import script from "./PromoDates.vue?vue&type=script&lang=js&"
export * from "./PromoDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDatePicker,VForm,VMenu,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1651673699/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65192434')) {
      api.createRecord('65192434', component.options)
    } else {
      api.reload('65192434', component.options)
    }
    module.hot.accept("./PromoDates.vue?vue&type=template&id=65192434&", function () {
      api.rerender('65192434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PromoDates.vue"
export default component.exports